import type { Enforcer } from "casbin";
import { newEnforcer, newModelFromString } from "casbin";
import { MODEL } from "./model";
import { UserId } from "@visioni/a3s-users";
import { CameraAction, SerializedPermissionsCodec } from "./schemas";
import SerializedPermissionsAdapter from "./adapter/serialized-permissions-adapter";
import { AssetCameraKey, SiteId, TenantId } from "@visioni/a3s-schema";

export type TenantEnforcer = { enforcer: Enforcer; domain: string };

export class Authorizer {
  static fromCasbinEnforcer(enforcer: Enforcer): Authorizer {
    return new Authorizer(enforcer);
  }

  /**
   * @see {@link SerializedPermissionsCodec} for the input to this function.
   */
  static async fromSerializedPermissions(serialized: string): Promise<Authorizer> {
    const adapter = new SerializedPermissionsAdapter(SerializedPermissionsCodec.decode(serialized));
    const enforcer = await newEnforcer(newModelFromString(MODEL), adapter);

    return new Authorizer(enforcer);
  }

  constructor(private readonly enforcer: Enforcer) {}

  canAccessCamera(
    tenant: TenantId,
    user: UserId,
    siteId: SiteId,
    assetCameraKey: AssetCameraKey,
    action: CameraAction,
  ): boolean {
    return this.enforcer.enforceSync(
      `user:${UserId.toString(user)}`,
      `tenant:${TenantId.toString(tenant)}`,
      `camera:${siteId}/${AssetCameraKey.toString(assetCameraKey)}`,
      action,
    );
  }

  isTenantAdmin(tenant: TenantId, user: UserId): boolean {
    return this.enforcer.enforceSync(
      `user:${UserId.toString(user)}`,
      `tenant:${TenantId.toString(tenant)}`,
      "ADMIN",
      "ADMIN",
    );
  }
}
